import React from 'react';
        export default class HistorySection extends React.Component {
        render() {
        return (
<section id="history-section" className="section history-section  d-flex align-items-center text-center">
    <div className="container">
        <h2>
            <span className="white">HISTORY </span>
            WHY CP Food Service
        </h2>
        <p>
            CP Food Service was established in 2001 as a family owned business. Initially, the business operated on a small scale servicing a few restaurants and shops with one truck and a limited range of products. </p>
        <p>As the years grew, so did the company. CP Food Service inherited a larger customer base and expanded physically in terms of product range, staff members, storage facility and delivery vehicles.
        </p>
        <p>
            Today, CP Food Service is renowned as a trusted supplier and services over 200 customers with both locally and internationally sourced products. Our business operates from multiple warehouse units in the Interlink Business Park in Homebush West, New South Wales. Vehicles are professionally equipped to cater for dry or frozen goods and small or large orders.</p>
        <p>If you own or manage your own hospitality or retail business, contact us today to see if we can help. </p>
    </div>
</section>
                )
        }
        }



// WEBPACK FOOTER //
// ./src/components/Home/History-Section.js